import React from 'react';
import moment from 'moment'
import Menu from '@material-ui/core/Menu';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom'
import MenuItem from '@material-ui/core/MenuItem'

class Item extends React.Component {
    render() {
        return (
                <div {...this.props}>
                    {this.props.item.activo &&
                    <div className='containerItemContenido'>
                        <div className='containerInfoItem'>
                            <div className='imgItem'>
                                {<img src={this.props.item.pathImagen && this.props.item.idTipoContenido !== 3 ? this.props.item.pathImagen : require('../../images/AvatarPreguntasFrecuentes.png')} onDragStart={(e)=>{e.preventDefault();}} alt=""/>}
                            </div>
                            <div className='infoItem'>
                                <div className='textoContenido'>{this.props.item.textoCorto.slice(0, 25) + (this.props.item.textoCorto.length > 25 ? '...' : '')}</div>
                                {(this.props.item.fechaActivacion && this.props.item.fechaDesactivacion) && <div>Desde {`${moment(this.props.item.fechaActivacion, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}`} Hasta {`${moment(this.props.item.fechaDesactivacion, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}`}</div>}
                                <div>{`${this.props.item.nombreUsuarioRegistro}`}</div>
                                {/* <div>{x.activo === true ? 'Activo' : 'Inactivo'}</div> */}
                            </div>
                        </div>

                        <div onClick={(e)=>{e.stopPropagation()}}>
                            <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                                {popupState => (
                                    <React.Fragment>
                                        <IconButton {...bindTrigger(popupState)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu {...bindMenu(popupState)}>
                                            <MenuItem onClick={(...args) => {this.props.handleOnClickVer(this.props.item); popupState.close(...args)}}>Ver</MenuItem>
                                            <MenuItem>
                                                <Link
                                                    to={{
                                                        pathname: `/Contenido/Editar/${this.props.item.idContenido}`,
                                                        key: Math.random(),
                                                        state: {
                                                        applied: true
                                                        }
                                                    }}
                                                    style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
                                                >
                                                    Editar
                                                </Link>
                                            </MenuItem>
                                            <MenuItem onClick={(...args) => {this.props.handleOnClickBorrar(this.props.item, false); popupState.close(...args)}}>Borrar</MenuItem>
                                        </Menu>
                                    </React.Fragment>
                                )}
                            </PopupState>
                        </div>
                    </div>}
                </div>
        )
    }
}

export default Item